export enum DatePickerErrors {
  INVALID_FORMAT = 'invalidFormat',
  REQUIRED_BEFORE = 'requiredBefore',
  REQUIRED_AFTER = 'requiredAfter'
}
